import React from 'react';
import get from 'lodash/get';
import {
  format, isAfter, isSameDay, startOfDay,
} from 'date-fns';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import AlarmIcon from '@mui/icons-material/Alarm';
import Tooltip from '@mui/material/Tooltip';
import useStyles from '../../utils/useStyles';
import './styles.css';

const MerchantHeader = (props) => {
  const invoiceTitle = get(props, 'quickInvoice.quick_invoice.title', '');
  const dueDate = get(props, 'quickInvoice.quick_invoice.due_date', '');
  const remainingBalance = get(props, 'quickInvoice.quick_invoice.remaining_balance', '');
  const invoiceNumber = get(props, 'quickInvoice.quick_invoice.invoice_number', '');
  const logo1 = get(props, 'quickInvoice.cc_product_transaction.receipt_logo');
  const logo2 = get(props, 'quickInvoice.ach_product_transaction.receipt_logo');
  const logo3 = get(props, 'quickInvoice.domain.nav_logo');
  const locationName = get(props, 'quickInvoice.location.name') || '';
  const locationAddress1 = get(props, 'quickInvoice.location.address1');
  const locationAddress2 = get(props, 'quickInvoice.location.address2');
  const city = get(props, 'quickInvoice.location.city') || '';
  const state = get(props, 'quickInvoice.location.state') || '';
  const zip = get(props, 'quickInvoice.location.zip_code') || '';

  const styles = useStyles();

  let locationAddressLineOne = '';
  let locationAddressLineTwo = '';
  if (locationAddress1 && !locationAddress2) {
    locationAddressLineOne = `${locationAddress1}, ${city}, ${state} ${zip}`;
  } else if (!locationAddress1 && locationAddress2) {
    locationAddressLineOne = `${locationAddress2}, ${city}, ${state} ${zip}`;
  } else if (locationAddress1 && locationAddress2) {
    locationAddressLineOne = `${locationAddress1}, ${locationAddress2}`;
    locationAddressLineTwo = `${city}, ${state} ${zip}`;
  }

  let invoiceHeaderClassName = 'invoice-on-time';
  let invoiceHeaderIcon = <MonetizationOnOutlinedIcon className="merchant-header-invoice-icon" />;
  let invoiceHeaderText = dueDate ? `Pay by ${format(new Date(dueDate), 'MMMM dd, yyyy')}` : '';

  if (parseFloat(remainingBalance) === 0) {
    invoiceHeaderClassName = 'invoice-on-time';
    invoiceHeaderIcon = <MonetizationOnOutlinedIcon className="merchant-header-invoice-icon" />;
    invoiceHeaderText = 'No balance due.';
  } else if (isAfter(startOfDay(new Date()), startOfDay(new Date(dueDate)))) {
    invoiceHeaderClassName = 'invoice-over-due';
    invoiceHeaderIcon = <AlarmIcon className="merchant-header-invoice-icon" />;
    invoiceHeaderText = 'Your payment is past due.';
  } else if (isSameDay(new Date(), new Date(dueDate))) {
    invoiceHeaderClassName = 'invoice-due-today';
    invoiceHeaderIcon = <MonetizationOnOutlinedIcon className="merchant-header-invoice-icon" />;
    invoiceHeaderText = 'Your payment is due.';
  }

  return (
    <AppBar className="quick-invoice-app-bar" position="relative">
      <Toolbar className="merchant-header-banner">
        <div className="header-wrapper">
          <div className="merchant-logo-wrapper">
            {logo1 && <img src={logo1} alt="Merchant logo." />}
            {logo2 && !logo1 && <img src={logo2} alt="Merchant logo." />}
            {logo3 && !logo1 && !logo2 && <img src={logo3} alt="Merchant logo." />}
          </div>
          <div className={invoiceHeaderClassName}>
            <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
              {invoiceHeaderIcon}
            </div>
            <div className="merchant-header-invoice-info">
              <Tooltip
                slotProps={{ tooltip: { sx: styles.tooltip } }}
                placement="right-end"
                title={invoiceTitle}
              >
                <div className="invoice-banner-text-one">{invoiceTitle}</div>
              </Tooltip>
              <div className="invoice-banner-text-two">{invoiceHeaderText}</div>
              <div className="merchant-header-invoice-number">
                <Tooltip
                  slotProps={{ tooltip: { sx: styles.tooltip } }}
                  placement="right-end"
                  title={invoiceNumber ? `#${invoiceNumber}` : ''}
                >
                  <div className="invoice-banner-text-pound">{invoiceNumber ? `#${invoiceNumber}` : invoiceNumber}</div>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="mailing-address-wrapper">
            <div className="mailing-address-name">{locationName}</div>
            <div className="mailing-address">{locationAddressLineOne}</div>
            <div className="mailing-address">{locationAddressLineTwo}</div>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default MerchantHeader;
